// Define types instead of importing from @/types
export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json }
  | Json[];

export interface CasePrediction {
  id: string;
  user_id: string | null;
  case_type: string;
  jurisdiction: string;
  court: string | null;
  claim_amount: number | null;
  case_summary: string;
  key_arguments: string | null;
  precedents: { expediente: string }[];
  recommendations: { description: string; icon: string }[];
  probability: number | null;
  estimated_amount: number | null;
  estimated_time: string | null;
  created_at: string;
  updated_at: string;
}

export interface LegalPrecedent {
  expediente: string;
  court: string;
  outcome: string;
  summary: string | null;
}

// Helper function to transform DB data to CasePrediction
export const transformToCasePrediction = (
  data: Record<string, unknown>
): CasePrediction => {
  // Handle recommendations - convert from Json to proper typed array
  let recommendations: { description: string; icon: string }[] = [];
  if (Array.isArray(data.recommendations)) {
    recommendations = data.recommendations.map(
      (rec: Record<string, unknown>) => ({
        description: (rec.description as string) || "",
        icon: (rec.icon as string) || "",
      })
    );
  }

  // Handle precedents - convert from Json to proper typed array
  let precedents: { expediente: string }[] = [];
  if (Array.isArray(data.precedents)) {
    precedents = data.precedents.map(
      (prec: string | Record<string, unknown>) => ({
        expediente:
          typeof prec === "string" ? prec : (prec.expediente as string) || "",
      })
    );
  }

  return {
    id: data.id as string,
    user_id: data.user_id as string | null,
    case_type: data.case_type as string,
    jurisdiction: data.jurisdiction as string,
    court: data.court as string | null,
    claim_amount: data.claim_amount as number | null,
    case_summary: data.case_summary as string,
    key_arguments: data.key_arguments as string | null,
    precedents: precedents,
    recommendations: recommendations,
    probability: data.probability as number | null,
    estimated_amount: data.estimated_amount as number | null,
    estimated_time: data.estimated_time as string | null,
    created_at: data.created_at as string,
    updated_at: data.updated_at as string,
  };
};
